import { utils, writeFile } from 'xlsx';

export default function ExportButtons({ data }) {
  const exportExcel = () => {
    const ws = utils.json_to_sheet(data);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Calificaciones');
    writeFile(wb, 'Calificaciones.xlsx');
  };

  const exportCSV = () => {
    const ws = utils.json_to_sheet(data);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Calificaciones');
    writeFile(wb, 'Calificaciones.csv');
  };

  return (
    <div style={{ marginBottom: '10px' }}>
      <button onClick={exportExcel}>Exportar Excel</button>
      <button onClick={exportCSV} style={{ marginLeft: '10px' }}>Exportar CSV</button>
    </div>
  );
}
